import { c as _c } from "react/compiler-runtime";
import ListingGridItem from '@/features/global-search-banner/components/listing-grid-item/listing-grid-item';
import { DEFAULT_LISTING_PART_VARIANTS } from '@/features/listing/constants/listing-constants';
import getTypedObjectKeys from '@/shared/utils/get-typed-object-keys';
import styles from './listing-grid.module.scss';
export const SERVICE_TYPE_MAP_MAIN = getTypedObjectKeys(DEFAULT_LISTING_PART_VARIANTS);
export default function ListingGrid() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className={styles.listingGrid}>{SERVICE_TYPE_MAP_MAIN.map(_temp)}</div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}
function _temp(serviceType) {
  return <ListingGridItem key={serviceType} listingType={serviceType} />;
}